var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 16.0001C21.3334 18.9456 18.9456 21.3334 16.0001 21.3334C13.0545 21.3334 10.6667 18.9456 10.6667 16.0001C10.6667 13.0545 13.0545 10.6667 16.0001 10.6667C18.9456 10.6667 21.3334 13.0545 21.3334 16.0001Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7126 2.48395C14.7481 0.755998 17.252 0.756001 18.2875 2.48396L19.2285 4.05431C19.8323 5.06204 21.0246 5.55586 22.1641 5.27029L23.9399 4.82528C25.8939 4.3356 27.6645 6.10616 27.1748 8.06018L26.7298 9.83598C26.4442 10.9756 26.9381 12.1678 27.9458 12.7716L29.5161 13.7126C31.2441 14.7481 31.2441 17.252 29.5161 18.2875L27.9458 19.2285C26.9381 19.8323 26.4442 21.0246 26.7298 22.1641L27.1748 23.9399C27.6645 25.8939 25.8939 27.6645 23.9399 27.1748L22.1641 26.7298C21.0246 26.4442 19.8323 26.9381 19.2285 27.9458L18.2875 29.5161C17.252 31.2441 14.7481 31.2441 13.7126 29.5161L12.7716 27.9458C12.1678 26.9381 10.9755 26.4442 9.83598 26.7298L8.06018 27.1748C6.10615 27.6645 4.3356 25.8939 4.82528 23.9399L5.27029 22.1641C5.55586 21.0246 5.06204 19.8323 4.05431 19.2285L2.48395 18.2875C0.755998 17.252 0.756001 14.7481 2.48396 13.7126L4.05431 12.7716C5.06204 12.1678 5.55586 10.9755 5.27029 9.83598L4.82528 8.06018C4.3356 6.10615 6.10616 4.3356 8.06018 4.82528L9.83598 5.27029C10.9755 5.55586 12.1678 5.06204 12.7716 4.05431L13.7126 2.48395Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLight);
export default __webpack_public_path__ + "static/media/setting-light.4a18ae26cd70443101deff1d0e552572.svg";
export { ForwardRef as ReactComponent };